import { FormGroup, NumericInput } from "@blueprintjs/core";
import type { ExtraFieldTypeNumber } from "@package/ui-gql/index-data-access";
import { get, set } from "lodash";
import { useMemo } from "react";
import { isConditionFalsey } from "../service-data-form-utils";
import type { ServiceDataFormFieldBaseProps } from "./ServiceDataFormFieldEmpty";

type ServiceDataFormFieldNumberProps = ServiceDataFormFieldBaseProps & {
  field: ExtraFieldTypeNumber;
};

function ServiceDataFormFieldNumberContent({
  data,
  field,
  onSourceChanged,
}: ServiceDataFormFieldNumberProps) {
  const value = useMemo<string>(
    () => get(data, field.source) ?? field.defaultValue ?? "",
    [data, field.defaultValue, field.source],
  );
  const disabled = useMemo<boolean>(
    () => !!field.condition && isConditionFalsey(field.condition, data),
    [data, field.condition],
  );

  return (
    <FormGroup disabled={disabled} label={field.label} fill>
      <NumericInput
        disabled={disabled}
        fill
        value={value}
        onValueChange={(value) =>
          onSourceChanged((draft) => {
            set(draft, field.source, value);
          })
        }
      />
    </FormGroup>
  );
}

export function ServiceDataFormFieldNumber({
  field,
  onSourceChanged,
  data,
}: ServiceDataFormFieldBaseProps) {
  if (field.__typename === "ExtraFieldTypeNumber") {
    return (
      <ServiceDataFormFieldNumberContent
        field={field}
        data={data}
        onSourceChanged={onSourceChanged}
      />
    );
  }

  return null;
}
